import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mcommerce-virtual-cash-register-breadcrumb-card',
  templateUrl: './mcommerce-virtual-cash-register-breadcrumb-card.component.html',
  styleUrls: ['./mcommerce-virtual-cash-register-breadcrumb-card.component.scss']
})
export class McommerceVirtualCashRegisterBreadcrumbCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
